import React from 'react';

// Containers
import SearchBox from '../containers/SearchBox';

// Components
import HeroLink from './HeroLink';

// Helper
import Page from '../../lib/page';
import i18n from '../../lib/reacti18n';
import { trackLink } from '../../lib/analytics-helper';

const links = {
  community: Page.getCommunityLink(),
  resolutionCenter: Page.getResolutionURL(),
  smartHelpHome: Page.getHomeURL(),
};

const labels = {
  communitySmallScreen: i18n.message('smarthelp/heroSection.heroLinks.community.smallScreen'),
  communityLargeScreen: i18n.message('smarthelp/heroSection.heroLinks.hcr.community.largeScreen'),

  resolutionSmallScreen: i18n.message('smarthelp/heroSection.heroLinks.resolution.smallScreen'),
  resolutionLargeScreen: i18n.message('smarthelp/heroSection.heroLinks.resolution.largeScreen'),

  emailSmallScreen: i18n.message('smarthelp/heroSection.heroLinks.email.smallScreen'),
  emailLargeScreen: i18n.message('smarthelp/heroSection.heroLinks.email.largeScreen'),
};

const HelpHeading = i18n.message('includes/common/quicknav.help_center');
let FPTIId = '';

const HeroSectionNoLink = () => {
  const FptiTracking = (fptiStr) => {
    FPTIId = Page.getFPTIPageId();
    trackLink({ id: FPTIId, link: `smarthelp-hero-links|${fptiStr}` });
  };

  const renderCommunity = () => {
    if (links.community) {
      return (
        <HeroLink
          type="community"
          link={links.community}
          message={{
            full: labels.communityLargeScreen,
            short: labels.communitySmallScreen,
          }}
          clickHandler={FptiTracking}
        />
      );
    }
    return null;
  };

  const renderResolutionCenter = () => {
    if (links.resolutionCenter) {
      return (
        <HeroLink
          type="resolution"
          link={links.resolutionCenter}
          message={{
            full: labels.resolutionLargeScreen,
            short: labels.resolutionSmallScreen,
          }}
          clickHandler={FptiTracking}
        />
      );
    }
    return null;
  };

  const renderHeroModule = () => {
    FPTIId = Page.getFPTIPageId();
    return (<div className="hero-selection-hcr">
      <div className="hero-selection-hcr-content">
        <div className="hero-selection-home-link">
          <a href={links.smartHelpHome} className="hero-selection-heading">{HelpHeading}</a>
        </div>
        <div className="search-box-container">
          <SearchBox FPTIId={FPTIId} />
        </div>
        <div className="hero-selection-placeholder">
          <div className="hero-links">
            {renderCommunity()}
            {renderResolutionCenter()}
          </div>
        </div>
      </div>
    </div>);
  };
  return renderHeroModule();
};

export default HeroSectionNoLink;
